<template>
  <div class="notification-panel">
    <header class="notification-panel__header">
      <span class="notification-panel__title">Notificações</span>
      <button
        v-if="showMarkAll"
        type="button"
        class="btn btn-link btn-sm notification-panel__mark-all"
        @click="$emit('mark-all')"
      >Marcar todas como lidas</button>
    </header>
    <div class="notification-panel__content">
      <div v-if="isLoading" class="notification-panel__state">Carregando...</div>
      <div v-else-if="!items.length" class="notification-panel__state">Nenhuma notificação</div>
      <ul v-else class="notification-panel__list">
        <li
          v-for="item in items"
          :key="item.id || item.createdAt || item.title"
          class="notification-panel__item"
          :class="{
            'notification-panel__item--unread': isUnread(item),
            'notification-panel__item--screen': isScreen(item),
          }"
          @click="isScreen(item) && $emit('open', item)"
        >
          <div class="notification-panel__item-title">{{ item.title }}</div>
          <div class="notification-panel__item-description" v-html="formatMessage(item.message)" />
          <span v-if="isScreen(item)" class="notification-panel__item-link">Ver novidades</span>
          <div
            v-if="item.createdAt || item.date"
            class="notification-panel__item-date">
            {{ formatDate(item.createdAt || item.date) }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showMarkAll: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isScreen(item) {
      return item.display === 'modal';
    },
    isUnread(item) {
      return !item.read && !item.readAt;
    },
    formatMessage(message) {
      if (!message) {
        return '';
      }

      return String(message)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/\n/g, '<br>');
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      return moment(value).format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.notification-panel {
  background-color: $light-color;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  box-shadow: 0 12px 32px rgba(27, 48, 61, 0.18);
  min-width: 320px;
  max-width: 420px;
  position: absolute;
  right: 0;
  top: calc(100% + 0.4rem);
  z-index: $zindex-4;

  &__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: $layout-spacing $layout-spacing-lg;
    border-bottom: 1px solid $border-color;
  }

  &__title {
    font-size: $font-size-sm;
    font-weight: 600;
    color: $dark-color;
    margin: $layout-spacing-sm 0
  }

  &__mark-all {
    font-size: $font-size-xs;
    padding: 0;
  }

  &__content {
    max-height: 360px;
    overflow-y: auto;
  }

  &__state {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    padding: $layout-spacing-lg;
    text-align: center;
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    border-bottom: 1px solid $border-color;
    padding: $layout-spacing $layout-spacing-lg;

    &:last-child {
      border-bottom: none;
    }
  }

  &__item--unread {
    background-color: $bg-color;
  }

  &__item--screen {
    cursor: pointer;

    &:hover {
      background-color: $gray-color-ultra-light;
    }
  }

  &__item-link {
    color: $primary-color;
    display: inline-block;
    font-size: $font-size-xs;
    font-weight: 600;
    margin-top: $layout-spacing-sm;
  }

  &__item-title {
    font-size: $font-size-sm;
    font-weight: 600;
    margin-bottom: $layout-spacing-sm;
    color: $dark-color;
  }

  &__item-description {
    color: $gray-color-dark;
    font-size: $font-size-xs;
    line-height: 1.4;
  }

  &__item-date {
    color: $gray-color;
    font-size: $font-size-xs;
    margin-top: $layout-spacing-sm;
  }
}
</style>
